<template>
  <el-main>
    <directory/>
  </el-main>
</template>

<script>
  // components
  import Directory from './directory/Directory.vue';

  export default {
    name: 'PageContent',
    components: {
      Directory
    },
  }
</script>
